module.exports = __webpack_public_path__ + "img/icn_reveal.9943c4ec.svg";